import { AvailablePackageCard } from './AvailablePackageCard';
import { AvailablePackage } from '../../../../services/student/packages.interfaces';

export type DisponiveisEmptyReason = 'shop-empty' | 'already-owned';

interface AvailablePackagesSectionProps {
  packages: AvailablePackage[];
  emptyReason?: DisponiveisEmptyReason;
  onGoToMyPackages?: () => void;
}

export const AvailablePackagesSection = ({
  packages,
  emptyReason = 'shop-empty',
  onGoToMyPackages,
}: AvailablePackagesSectionProps) => {
  return (
    <div className="px-6 py-10 bg-background rounded-t-[32px] mt-6">
      <div className="mb-8">
        <h2 className="text-foreground text-base font-medium">
          Pacotes disponíveis
        </h2>
        <p className="text-text-secondary text-sm mt-1">
          Escolha um pacote alinhado à sua proficiência e continue aprendendo.
        </p>
      </div>

      {packages.length === 0 ? (
        emptyReason === 'already-owned' ? (
          <div className="rounded-xl border border bg-surface px-5 py-8">
            <p className="text-sm font-medium text-foreground">
              Você já tem os pacotes disponíveis
            </p>
            <p className="mt-1 text-sm text-text-secondary">
              O conteúdo está em Meus pacotes. Volte mais tarde se novas ofertas forem publicadas.
            </p>
            {onGoToMyPackages ? (
              <button
                type="button"
                onClick={onGoToMyPackages}
                className="mt-4 text-sm font-medium text-foreground underline underline-offset-4 hover:text-foreground/80"
              >
                Ir para Meus pacotes
              </button>
            ) : null}
          </div>
        ) : (
          <div className="rounded-xl border border bg-surface px-5 py-8">
            <p className="text-sm font-medium text-foreground">Nenhum pacote à venda agora</p>
            <p className="mt-1 text-sm text-text-secondary">
              Se você já comprou, o conteúdo está em Meus pacotes. Volte mais tarde para novas ofertas.
            </p>
          </div>
        )
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pb-8">
          {packages.map((pkg) => (
            <AvailablePackageCard key={pkg.id} pkg={pkg} />
          ))}
        </div>
      )}
    </div>
  );
};
